import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { SendTestMessageResponse } from "@/pages/Private/pages/Account/schema/sendTestMessage";

interface TestMessagePreviewProps {
	preview: SendTestMessageResponse;
}

/**
 * Renders the rendered-message preview returned by `POST schedule/send-test-message`.
 * Shared by the node-based `SendTestMessageModal` and the inbox-chat
 * `SendTestChatMessageModal`.
 */
export const TestMessagePreview: FunctionComponent<TestMessagePreviewProps> = ({ preview }) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`campaign.sendTest.${key}`);

	return (
		<div className="flex flex-col gap-2 border border-border-light rounded-lg p-3 bg-brand-white">
			<div className="text-text text-ssm font-semibold">{ts("previewTitle")}</div>
			{preview.renderedSubject && (
				<div className="text-text-meta text-xs">
					<span className="font-semibold">{ts("previewSubject")}: </span>
					{preview.renderedSubject}
				</div>
			)}
			{preview.channel === "email" ? (
				<div
					className="text-text text-sm"
					dangerouslySetInnerHTML={{ __html: preview.renderedMessage }}
				/>
			) : (
				<div className="text-text text-sm whitespace-pre-wrap">{preview.renderedMessage}</div>
			)}
			<div className="text-text-meta text-xs">
				<span className="font-semibold">{ts("previewSentTo")}: </span>
				{preview.sentTo}
			</div>
		</div>
	);
};
